module.exports = __webpack_public_path__ + "static/media/ticket-active.269bb799.svg";